import {portalRedirect} from '@/router/portalRedirect'

// Preserve bookmarks without mounting the retired panel layout.
const destinations = [
    ['dashboard', 'portalHome'], ['basket', 'basket'],
    ['sessions', 'portalSessions'], ['sessions/request', 'sessions-request'],
    ['factors', 'portalPayments'], ['user-onboarding', 'userOnboarding'],
    ['packages', 'portalPackage'], ['roots-in-soil', 'roots-in-soil'],
    ['tests', 'tests'], ['test/:testID', 'test_history'],
    ['setting', 'setting'], ['tasks', 'tasks'], ['factor/:factorID', 'factor'],
    ['mental-ai-tool', 'chatGpt'], ['invitees', 'invitees'],
    ['event/:id', 'eventDetail'], ['myoutcome', 'portalProgress'],
]

export default [
    {path: 'panel', redirect: portalRedirect('portalHome')},
    ...destinations.map(([path, name]) => ({path: `panel/${path}`, redirect: portalRedirect(name)})),
]
